import React from "react";
import housingIcon from "../../PicesForPages/equal-housing-opportunity-logo-100-w.png";
import whatsappIcon from "../../PicesForPages/WhatsappIconWithLabel.png";
import { Link } from "react-router-dom";

function Footer() {
  // Scroll to the top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };
  return (
    <div className="footerParent">
      <div className="footerBox">
        <div className="footerTop">
          <div className="footerTopDiv footerTopDiv01">
            <span className="footerTopDivHeading">About Our Team</span>

            {/* <span className='footerTopDivContent footerTopDivContent00'>We strive to deliver the highest <br />levels of service to help you <br />reach your goals. We thank you <br />for your trust and support. <br />From the first call to closing, <br />our team is with you every step <br />of the way!</span> */}
            <span className="footerTopDivContent footerTopDivContent00">
              We work hard to deliver outstanding service that helps you achieve
              your goals. Your trust and support mean the world to us. Rest
              assured, our team will be with you through every step of the
              process, from the first call to the closing!
            </span>
          </div>
          <div className="footerTopDiv footerTopDiv01">
            {/* <span className='footerTopDiv footerTopDiv00'>
                            <span className='footerTopDivHeading'>Connect With Us</span>
                            <span className='footerTopDivContent footerTopDivContentSM'><i class="ri-facebook-box-fill"></i> <i class="ri-linkedin-box-fill"></i> <i class="ri-mail-fill"></i></span>
                        </span> */}
            <span className="footerTopDiv footerTopDiv00 ">
              <span className="footerTopDivHeading">Contact Us</span>
              <span className="footerTopDivContent footerTopDivContent00">
                <a
                  href="https://maps.app.goo.gl/qb91fbeTXbMUL3xt5"
                  target="_blank"
                  rel="noreferrer"
                  className="footerTopDivContentIcon"
                >
                  <i class="ri-map-pin-line"></i>{" "}
                  <span>
                    2120 Crown Centre Dr, <br />
                    Suite 400A,
                    <br />
                    Charlotte, NC 
                    <br />
                    28227
                  </span>
                </a>
                <a
                  href="tel:+1-833-745-6684"
                  className="aTag_Tel footerTopDivContentIcon"
                >
                  <i class="ri-phone-fill"></i> <span>(833) 745-6684</span>
                </a>
                <a
                  href="mailto: contact@primehomemtg.com"
                  className="aTag_Mail footerTopDivContentIcon"
                >
                  <i class="ri-mail-send-fill"></i>{" "}
                  <span>contact@primehomemtg.com</span>
                </a>
              </span>
            </span>
          </div>
          <div className="footerTopDiv">
            <span className="footerTopDivHeading">Loan Options</span>
            <span className="footerTopDivContent footerTopDivContent00">
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption01"
              >
                Fixed Rate Mortgage
              </Link>
              <Link to="/fha" className="LoanOption LoanOption02">
                FHA Home Loan
              </Link>
              <Link to="/va-loans" className="LoanOption LoanOption03">
                VA Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption04"
              >
                Jumbo Home Loan
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption05"
              >
                First Time Home Buyer
              </Link>
              <Link
                to="/which-loan-is-right-for-me"
                className="LoanOption LoanOption06"
              >
                Investment Property Loans
              </Link>
              <Link to="/refinancing" className="LoanOption LoanOption07">
                Refinance
              </Link>
              <Link to="/" className="LoanOption LoanOption08">
                DSCR/Short term rental loans
              </Link>
            </span>
          </div>
          <div className="footerTopDiv">
            <span className="footerTopDivHeading">Resources</span>
            <span className="footerTopDivContent footerTopDivContent00">
              <Link to="/contact-us" className="Resource Resource01">
                Contact Us
              </Link>
              <Link to="quick-quote" className="Resource Resource02">
                Get A Quote
              </Link>
              <Link
                to="https://www.blink.mortgage/app/signup/p/primehomemortgageincorporated/"
                className="Resource Resource04"
                target="_blank"
              >
                Apply
              </Link>
              <Link to="/testimonials" className="Resource Resource05">
                Reviews
              </Link>
              <Link
                // to="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2658067"
                to="https://www.nmlsconsumeraccess.org/Home.aspx/SubSearch?SearchText=prime%20home%20mortgage%20incorporated&Page=1"
                target="_blank"
                className="Resource Resource06"
              >
                NMLS Consumer Access
              </Link>
              <Link
                to="/ada-accessibility-statement"
                className="Resource Resource07"
              >
                ADA Accessibility Statement
              </Link>
              <Link to="/privacy-policy" className="Resource Resource03">
                Privacy Policy
              </Link>
            </span>
          </div>
        </div>
        <div className="footerMiddle">
          <img
            fetchPriority="high"
            loading="eager"
            src={housingIcon}
            alt="houseIcon"
            className="houseIcon"
          />
          <b>Equal Housing Opportunity </b>
          <br />
          <span> Prime Home Mortgage, INC </span> |{" "}
          <span>Company NMLS: 2658067</span>
        </div>
        <div className="footerBottom">
          <span>
            Licensed in States - AL, CO, FL, GA, MD, NC, NJ, OR, PA, SC, TX, VA
            & WA
          </span>
          {/* <span>Licensed in States GA, NC, OR, PA, SC, TX and VA</span> */}

          {/* <span className="footerBottomDown">

            <b>
              Powered by{" "}
              <a
                href="https://shushanktech.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="shushankTechLink"
              >
                ShushankTech
              </a>
            </b>
            <span className="footerBottomDown02">
              This site is protected by{" "}
              <a
                href="https://shushanktech.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noopener noreferrer"
              >
                ShushankTech
              </a>{" "}
              <b>Privacy Policy</b> and <b>Terms of Service</b> apply.
            </span>
          </span> */}
          <span className="footerBottomDown">
            <b>
              Powered by{" "}
              <a
                href="https://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds
              </a>
            </b>
            <span className="footerBottomDown02">
              This site is protected by{" "}
              <a
                href="https://staiminds.com/"
                className="shushankTechLink"
                target="_blank"
                rel="noreferrer"
              >
                ST AI Minds
              </a>{" "}
              <b>Privacy Policy</b> and <b>Terms of Service</b> apply.
            </span>
          </span>
        </div>
        <a
          href="https://www.linkedin.com/in/pandugayala-raja-naresh-b15b4986/"
          className="Developer"
          target="_blank"
          rel="noreferrer"
        >
          Crafted by: Pandugayala Raja Naresh | Web Developer
        </a>
        <div className="goTop" onClick={scrollToTop}>
          <span>TOP</span>
        </div>
        <div className="WhatsApp">
          <a
            href="https://wa.link/16qh0h"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              fetchPriority="high"
              loading="eager"
              src={whatsappIcon}
              alt="whatsappIcon"
              className="whatsappIcon"
            />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Footer;
